import './BlogWysiwyg.scss';

class BlogWysiwyg {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['BlogWysiwyg'] = BlogWysiwyg;
export default BlogWysiwyg;
